var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7513 21.6668H51.4596C54.3328 21.6668 57.0883 22.8082 59.12 24.8398C61.1516 26.8715 62.293 29.627 62.293 32.5002C62.293 35.3733 61.1516 38.1288 59.12 40.1605C57.0883 42.1921 54.3328 43.3335 51.4596 43.3335H48.7513M48.7513 21.6668H5.41797V46.0418C5.41797 48.915 6.55933 51.6705 8.59098 53.7022C10.6226 55.7338 13.3781 56.8752 16.2513 56.8752H37.918C40.7911 56.8752 43.5466 55.7338 45.5783 53.7022C47.6099 51.6705 48.7513 48.915 48.7513 46.0418V21.6668ZM16.2513 2.7085V10.8335M27.0846 2.7085V10.8335M37.918 2.7085V10.8335",
    stroke: "#F5F5F5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeBg);
export default __webpack_public_path__ + "static/media/CoffeeBG.bedecfa2ac77a5e854168059afbd2cee.svg";
export { ForwardRef as ReactComponent };